import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import type { ReactNode } from 'react';
import { AppShell, PageLoading, useBootstrap } from './components/Layout';
import { useAppStore } from './store';
import { OverviewPage, MapPage, AlertsPage, CamerasPage, DronesPage } from './pages/CorePages';
import { IncidentsPage } from './pages/IncidentPage';
import { MopupPage, PeatPage, PreventionPage, ResourcesPage, SmokePage } from './pages/OperationsPages';
import { SimulationPage } from './pages/SimulationPage';
import { AccessDenied, AdminPage, DataHealthPage, FieldPage, HelpPage, PublicPage, ReplayPage } from './pages/SystemPages';

export function App() {
  return <BrowserRouter><Routes>
    <Route path="/public" element={<PublicPage />} />
    <Route path="/field" element={<FieldPage />} />
    <Route element={<AppShell />}>
      <Route index element={<Landing />} />
      <Route path="overview" element={<Guard id="overview"><OverviewPage /></Guard>} />
      <Route path="map" element={<Guard id="map"><MapPage /></Guard>} />
      <Route path="alerts" element={<Guard id="alerts"><AlertsPage /></Guard>} />
      <Route path="cameras" element={<Guard id="cameras"><CamerasPage /></Guard>} />
      <Route path="drones" element={<Guard id="drones"><DronesPage /></Guard>} />
      <Route path="incidents" element={<Guard id="incidents"><IncidentsPage /></Guard>} />
      <Route path="incidents/:incidentId" element={<Guard id="incidents"><IncidentsPage /></Guard>} />
      <Route path="simulation" element={<Guard id="simulation"><SimulationPage /></Guard>} />
      <Route path="prevention" element={<Guard id="prevention"><PreventionPage /></Guard>} />
      <Route path="peat" element={<Guard id="peat"><PeatPage /></Guard>} />
      <Route path="resources" element={<Guard id="resources"><ResourcesPage /></Guard>} />
      <Route path="smoke" element={<Guard id="smoke"><SmokePage /></Guard>} />
      <Route path="mopup" element={<Guard id="mopup"><MopupPage /></Guard>} />
      <Route path="replay" element={<Guard id="replay"><ReplayPage /></Guard>} />
      <Route path="data" element={<Guard id="data"><DataHealthPage /></Guard>} />
      <Route path="help" element={<Guard id="help"><HelpPage /></Guard>} />
      <Route path="help/:topicId" element={<Guard id="help"><HelpPage /></Guard>} />
      <Route path="admin" element={<Guard id="admin"><AdminPage /></Guard>} />
      <Route path="*" element={<Navigate to="/overview" replace />} />
    </Route>
  </Routes></BrowserRouter>;
}

function Guard({ id, children }: { id: string; children: ReactNode }) {
  const { data, isLoading } = useBootstrap(); const role = useAppStore((state) => state.role);
  if (isLoading || !data) return <PageLoading />;
  const screen = data.navigation.screens.find((item) => item.id === id);
  return screen?.allowedRoles.includes(role) ? children : <AccessDenied screen={screen?.title} />;
}

function Landing() {
  const { data } = useBootstrap(); const role = useAppStore((state) => state.role);
  if (!data) return <PageLoading />;
  const route = ({ 'national-watch-officer': '/overview', 'incident-commander': '/incidents', 'drone-operator': '/drones', 'fire-analyst': '/alerts', 'field-responder': '/field', 'public-health-officer': '/smoke', 'prevention-planner': '/prevention', 'system-admin': '/admin', 'public-viewer': '/public' } as Record<string, string>)[role];
  const fallback = data.navigation.screens.find((screen) => screen.allowedRoles.includes(role));
  return <Navigate to={route ?? fallback?.route ?? '/help'} replace />;
}
